import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'

import Header from '../components/header'
import { headerProps } from '../components/HeaderConfig'
import Hero from '../components/hero'
import Highlights from '../components/highlights'
import FeaturedProjects from '../components/featured-projects'
import Mission from '../components/mission'
import ContactCard from '../components/contact-card'
import Footer from '../components/footer'
import ThemeToggle from '../components/theme-toggle'
import useTheme from '../hooks/useTheme'
import './home.css'

const Home = (props) => {
  const { isDark, toggleTheme } = useTheme()

  return (
    <div className="home-container">
      <Helmet>
        <title>Abhishek Palit | VDC Assistant Engineer, AI & Sustainability Expert</title>
        <meta
          name="description"
          content="VDC Assistant Engineer at Turner Construction Company specializing in BIM, AI/ML, sustainable construction, and digital fabrication. Stanford graduate advancing the built environment through technology."
        />
        <meta property="og:title" content="Abhishek Palit | VDC Engineer & Sustainability Expert" />
        <meta
          property="og:description"
          content="VDC Assistant Engineer specializing in BIM, AI, and sustainable construction technology."
        />
        <meta property="og:type" content="website" />
        <meta name="keywords" content="VDC, BIM, construction technology, AI, sustainability, Stanford, architecture, digital fabrication, Turner Construction" />
      </Helmet>
      <Header
        {...headerProps}
        rootClassName="headerroot-class-name1"
        themeToggle={<ThemeToggle isDark={isDark} toggleTheme={toggleTheme} />}
      />
      <Hero
        title={
          <Fragment>
            <span className="home-text19">
              Data-Driven Design and Automation for the Built Environment
            </span>
          </Fragment>
        }
        description={
          <Fragment>
            <span className="home-text20">
              Hi, I&apos;m Abhishek Palit — an architect and VDC engineer advancing
              the built environment through automation, sustainability, and
              technology.
            </span>
          </Fragment>
        }
      ></Hero>
      <Highlights />
      <FeaturedProjects />
      <Mission />
      <ContactCard />
      <Footer
        copyright="©2025 Abhishek Palit."
        rootClassName="footerroot-class-name2"
      ></Footer>
    </div>
  )
}

export default Home
